import * as api from 'dashboard/resources/net-sales.api';
import actionTypes from './action-types';

export const fetchNetSalesSummaryRequest = () => ({
  type: actionTypes.FETCH_NET_SALES_SUMMARY_REQUEST,
  isLoading: true,
});

export const fetchNetSalesSummarySuccess = (netSalesSummary) => ({
  type: actionTypes.FETCH_NET_SALES_SUMMARY_SUCCESS,
  netSalesSummary,
  isLoading: false,
});

export const fetchNetSalesSummaryFailure = () => ({
  type: actionTypes.FETCH_NET_SALES_SUMMARY_FAILURE,
  isLoading: false,
});

export const fetchNetSalesSummary = (retailerNo) => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const retailerId = retailerNo || session.retailer.retailerId;

    dispatch(fetchNetSalesSummaryRequest());

    const netSalesSummary = await api.fetchNetSalesSummary({ retailerId });
    dispatch(fetchNetSalesSummarySuccess(netSalesSummary));
  } catch (error) {
    console.error('NET_SALES_SUMMARY', error);
    dispatch(fetchNetSalesSummaryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/net-sales/net-sales-summary.actions.js